import { render, staticRenderFns } from "./SetupSAPHanaHarvester.vue?vue&type=template&id=2da8b064&"
import script from "./SetupSAPHanaHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupSAPHanaHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports